import ServletUrlUtil from "./ServletUrlUtil";

export default class WithdrawalUrlUtil extends ServletUrlUtil {

    withdrawalUrl = (paymentMethod) => {
        switch (paymentMethod) {
            case "creditCard":
                return this.veritransPremiumWithdrawalUrl();
            case "docomoPayment":
                return this.docomoPaymentWithdrawalUrl();
            case "auOne":
                return this.auPaymentPremiumWithdrawalUrl();
            case "auOneShift":
                return this.auPaymentShiftWithdrawalUrl();
            case "spMode":
                return this.spmodePremiumWithdrawalUrl();
            case "spModeShift":
                return this.spmodeShiftWithdrawalUrl();
            case "softbankPayment":
                return this.softBankAuthUrl('/sp/softbankwithdrawal/withdrawal/pictlinkauth', '/');
            default:
                return "";
        }
    }
}
